import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";

export class CustomOrderPlanningConfigurationSelectComponent implements IController {

  selectedId: any;
  options: any;
  optionIds: any;
  ngPlaceholder: any;
  excludeIds: any;
  isDisabled: any;
  isRequired: boolean;
  branchIds: string[];
  accountIds: string[];
  onChange: Function;

  private orderPlanningConfigurationRef: any;
  public selectedConfiguration: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $orderPlanningConfiguration, private $element) {
    this.orderPlanningConfigurationRef = this.$orderPlanningConfiguration();
  }

  $onInit() {
    this._setSelectedConfiguration();
  };

  $onChanges(changes) {
    if ((changes.selectedId && !changes.selectedId.isFirstChange())) {
      this._setSelectedConfiguration();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'service-areas-types="ctrl.serviceTypesRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'order-planning-configuration';
        this.selectedIdsRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.excludeIdsRef = excludeIdsRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({configuration: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            const configuration = _.find(this.options, (o) => {
              return o.id === selectedId;
            })
            this.onChange({configuration: configuration, id: selectedId});
            panel.destroy();
          } else {
            this.orderPlanningConfigurationRef.$asyncValues([selectedId])
              .then((configurations) => {
                this.onChange({configuration: configurations[0], id: selectedId});
                panel.destroy();
              });
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({configuration: undefined, id: undefined});
  }

  private _setSelectedConfiguration() {
    if (!!this.selectedId) {
      if (!!this.options) {
        this.selectedConfiguration = _.find(this.options, (o) => {
          return o.id === this.selectedId;
        });
        this._setSelectedText();
      } else {
        this.orderPlanningConfigurationRef.$asyncValues([this.selectedId])
          .then((configurations) => {
            this.selectedConfiguration = _.orderBy(configurations, ['name'], ['asc'])[0];
            this._setSelectedText()
          });
      }
    } else {
      this.selectedConfiguration = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = _.get(this.selectedConfiguration, 'name', '');
  }


}

angular
  .module('bringoz.admin.order-planning-configuration')
  .component('customOrderPlanningConfigurationSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<?',
      options: '<?',
      optionIds: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      isDisabled: '<?',
      isRequired: '<?',
      onChange: '&'
    },
    template: require('./custom-order-planning-configuration-select.html').default,
    controller: CustomOrderPlanningConfigurationSelectComponent
  });
